export default "__VITE_ASSET__CmVG2W2x__"